export default {
  calendar: {
    day_empty: 'Nothing requested today',
    title: 'Care Calendar',
    time_notice: 'All Times Pacific',
  },
};
